const handleTab = () => {
  const formElments = ["input", "textarea", "select"]

  // Determine if the user is a mouse or keyboard user
  function handleFirstTab(event) {
    if (
      event.key === "Tab" &&
      !formElments.includes(document.activeElement.tagName.toLowerCase())
    ) {
      document.body.classList.add("user-is-tabbing")

      window.addEventListener("mousedown", handleMouseDownOnce)
      window.removeEventListener("keydown", handleFirstTab)
    }
  }

  function handleMouseDownOnce() {
    document.body.classList.remove("user-is-tabbing")

    window.addEventListener("keydown", handleFirstTab)
    window.removeEventListener("mousedown", handleMouseDownOnce)
  }

  window.addEventListener("keydown", handleFirstTab)
}

const focusFormStatus = (node) => {
  const formStatus = node.querySelector(".form-status")

  if (!formStatus) return

  const focusElement = formStatus.querySelector("[data-form-status]")

  if (!focusElement) return

  focusElement.focus()
}

const prefersReducedMotion = () => {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches
}

export { handleTab, focusFormStatus, prefersReducedMotion }
